module.exports = __webpack_public_path__ + "static/media/Telephone.31671b4d.png";